import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import ImageItem from '@/components/formats/ShokurekishoParts/ImageItem.vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useShokurekishoFormatData } from '@/composables/format-edit/useShokurekishoFormatData'
import { useProvidedShokurekishoImageItems } from '@/composables/format-edit/useShokurekishoImageItems'
import type { BasicData } from '@/utils/format-edit/basicData'

type FeatureHooks = {
  onSuccess: () => void
  onCancel: () => void
  onError?: () => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoJobImageCard',
  props: {
    currentCardId: null,
    basicData: null
  },
  setup(__props: any) {



const descriptionMaxLength = 80
const formatData = useShokurekishoFormatData()
const { vm, globalVar, yagiprimePaymentService, message } = useHostServices()
const {
  activeImageItem,
  addImageItem,
  deleteImageItem,
  moveImageItem,
  activateImageItem
} = useProvidedShokurekishoImageItems()

const isYagiPrime = computed(() => !!globalVar.isYagiPrime)
const imageList = computed(() => formatData.imageItems || [])

function showPrimeUpsell() {
  yagiprimePaymentService.useFeature(vm, 'shokurekisho-with-image-add-item', {
    onSuccess: () => {
      addImageItem()
      message({
        message: '成功しました',
        type: 'success'
      })
    },
    onCancel: () => {},
    onError: () => {
      message({
        message: '失敗しました',
        type: 'error'
      })
    }
  } as FeatureHooks)
}

return { __sfc: true,descriptionMaxLength, formatData, vm, globalVar, yagiprimePaymentService, message, activeImageItem, addImageItem, deleteImageItem, moveImageItem, activateImageItem, isYagiPrime, imageList, showPrimeUpsell, ImageItem }
}

})